import React from 'react';

const AnimatedBackground = ({ opacity = 0.8 }) => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Large animated gradient orbs */}
      <div className="absolute -top-20 -left-20 w-[500px] h-[500px] bg-purple-400/40 rounded-full blur-3xl animate-float-slow"></div>
      <div className="absolute top-1/4 -right-20 w-[450px] h-[450px] bg-lavender-400/40 rounded-full blur-3xl animate-float" style={{ animationDuration: '10s', animationDelay: '1s' }}></div>
      <div className="absolute bottom-0 left-1/3 w-[400px] h-[400px] bg-violet-400/35 rounded-full blur-3xl animate-float" style={{ animationDuration: '12s', animationDelay: '2s' }}></div>
      <div className="absolute top-1/2 left-1/4 w-[350px] h-[350px] bg-purple-500/30 rounded-full blur-3xl animate-float-slow" style={{ animationDelay: '3s' }}></div>
      
      {/* Moving light beams */}
      <div className="absolute inset-0 opacity-50">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-white/15 via-transparent to-transparent animate-shimmer"></div>
        <div className="absolute bottom-0 right-0 w-full h-full bg-gradient-to-tl from-white/10 via-transparent to-transparent animate-shimmer" style={{ animationDelay: '1.5s' }}></div>
      </div>
      
      {/* Glowing rings */}
      <div className="absolute top-1/3 right-1/4 w-64 h-64 border-2 border-white/20 rounded-full animate-glow-pulse"></div>
      <div className="absolute bottom-1/4 left-1/3 w-48 h-48 border-2 border-purple-300/20 rounded-full animate-glow-pulse" style={{ animationDelay: '2s' }}></div>
      
      {/* Floating particles - more and bigger */}
      <div className="absolute inset-0" style={{ opacity }}>
        {[...Array(40)].map((_, i) => {
          const size = Math.random() > 0.7 ? 'w-2 h-2' : 'w-1 h-1';
          const brightness = Math.random() > 0.5 ? 'bg-white/60' : 'bg-purple-200/50';
          return (
            <div
              key={i}
              className={`absolute ${size} ${brightness} rounded-full animate-float`}
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDuration: `${6 + Math.random() * 10}s`,
                animationDelay: `${Math.random() * 5}s`,
              }}
            />
          );
        })}
      </div>
      
      {/* Sparkle effect */}
      <div className="absolute inset-0 opacity-60">
        {[...Array(15)].map((_, i) => (
          <div
            key={`sparkle-${i}`}
            className="absolute w-1 h-1 bg-white rounded-full animate-shimmer"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              boxShadow: '0 0 10px rgba(255, 255, 255, 0.8)',
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default AnimatedBackground;
